import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static get values() {
        return {
            context: String,
            active: Boolean,
        }
    }

    activeValueChanged() {
        if (this.activeValue) {
            this.element.classList.add('active');
        }
    }

    trigger(event) {
        const {
            detail: { context },
        } = event;

        if (context === this.contextValue ) {
            this.element.classList.add('active');
        } else {
            this.element.classList.remove('active');
        }
    }

    dispatch() {
        window.dispatchEvent(new CustomEvent('context-switch', {
            detail: {
                context: this.contextValue,
            },
        }));
    }
}
